import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import Modal from '../../../Modal';
import ActionButton from '../../../ActionButton';
import './_offlineModal.scss';

const OfflineModal = ({ open }) => (
  <Modal open={open} disableClose>
    <div className="offlineModal">
      <Typography>Oops...</Typography>
      <Typography className="message">No internet connection</Typography>
      <div className="btn-container">
        <ActionButton title="Reload" onClick={() => window.location.reload()} />
      </div>
    </div>
  </Modal>
);

OfflineModal.propTypes = {
  open: PropTypes.bool.isRequired
};

export default OfflineModal;